module.exports = __webpack_public_path__ + "img/PorscheCarrera.db728647.jpeg";